/**
 * Padel *games* won/lost from set scores (same rules as server/utils/teamPadelGameTotals.js).
 * Set 3 counts only when sets 1–2 were 1–1 and the third set was played (not 0–0).
 */

/**
 * @param {object} m - league_matches-shaped row
 * @param {string} teamId
 * @returns {{ gw: number, gl: number }}
 */
export function padelGamesWonLostFromLeagueMatch(m, teamId) {
  if (!m || !teamId) return { gw: 0, gl: 0 };
  let gw = 0;
  let gl = 0;
  const isT1 = m.team1_id === teamId;
  const s1 = isT1 ? m.team1_score_set1 : m.team2_score_set1;
  const o1 = isT1 ? m.team2_score_set1 : m.team1_score_set1;
  const s2 = isT1 ? m.team1_score_set2 : m.team2_score_set2;
  const o2 = isT1 ? m.team2_score_set2 : m.team1_score_set2;
  const s3 = isT1 ? m.team1_score_set3 : m.team2_score_set3;
  const o3 = isT1 ? m.team2_score_set3 : m.team1_score_set3;

  if (s1 != null && o1 != null) {
    gw += Number(s1);
    gl += Number(o1);
  }
  if (s2 != null && o2 != null) {
    gw += Number(s2);
    gl += Number(o2);
  }

  const won1 = s1 > o1;
  const won2 = s2 > o2;
  const setsWere1to1 = (won1 && !won2) || (!won1 && won2);
  const set3Counts =
    setsWere1to1 &&
    s3 != null &&
    o3 != null &&
    !(Number(s3) === 0 && Number(o3) === 0);
  if (set3Counts) {
    gw += Number(s3);
    gl += Number(o3);
  }

  return { gw, gl };
}

/**
 * @param {object} m
 * @returns {{ team1: { gw: number, gl: number }, team2: { gw: number, gl: number } } | null}
 */
export function getPadelGamesPairForMatch(m) {
  if (!m || m.status !== 'completed' || !m.team1_id || !m.team2_id) return null;
  const team1 = padelGamesWonLostFromLeagueMatch(m, m.team1_id);
  const team2 = padelGamesWonLostFromLeagueMatch(m, m.team2_id);
  const hasData = team1.gw + team1.gl + team2.gw + team2.gl > 0;
  if (!hasData) return null;
  return { team1, team2 };
}
